import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { Slide } from '../models/slide';

@Injectable({
  providedIn: 'root'
})
export class SlidesService {

  constructor(
    private _http:HttpClient
  )
  {}

  public getSlides():Observable<any>
  {
    return this._http.get<Slide[]>(environment.apiEndpoint + `/api/homepageSlides`).pipe(
      map(res => {
          return res;
      })
    );
  }
}
